import * as React from "react";
import {
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text";
import {
  IPendingCustomer,
  PendingCustomerStatus as PendingCustomerStatusEnum
} from "src/core/pending-customers/api/pendingCustomer.api";

import PendingCustomerStatus from "../PendingCustomerStatus";

/**
 * This function returns a reusable formated column definition for pending customer status column to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition
 */
export const pendingCustomerStatusColumn = <TData extends IPendingCustomer>(
  columnHelper: ColumnHelper<TData>,
  column: Partial<Pick<DisplayColumnDef<TData>, "header" | "id" | "cell">>
) => {
  const accessor = "status" as DeepKeys<TData>;

  return columnHelper.accessor(accessor, {
    id: column.id ? column.id : accessor,
    header: () => (
      <Text
        weight="bold"
        style={{ verticalAlign: "center" }}
      >
        {column.header ? column.header.toString() : typeof accessor === "string" ? accessor : ""}
      </Text>
    ),
    cell: column.cell ? column.cell : info => (
      <Text>
        <PendingCustomerStatus status={info.cell.getValue() as PendingCustomerStatusEnum} />
      </Text>
    ),
    enableSorting: false
  } as DisplayColumnDef<TData>);
};